import styled from 'styled-components';

import {commonPalette} from '../../styles/palette';
import $Icon from '../../components/Icon';
import {Button} from '../../components/Button';

export const ChangePasswordForm = styled.form`
  margin: 0;
  ${({isMobile}) => (isMobile ? 'width:350px' : 'width: 428px;')};
`;

export const Title = styled.div`
  text-align: ${({isMobile}) => (isMobile ? 'left' : 'center')};
  font-size: ${({isMobile}) => (isMobile ? '20px' : '24px')};
  margin-bottom: ${({isMobile}) => (isMobile ? '15px' : '40px')};
  color: ${commonPalette.txBlack};
  margin-left: ${({isMobile}) => (isMobile ? '1%' : '')};
  font-weight: 600;
`;
export const StyledText = styled.div`
  color: ${commonPalette.surfaceBrand};
  margin: 5px 0 15px 0;
  text-align: ${({alignText}) => (alignText ? alignText : 'center')};
  font-size: 14px;
`;

export const StyledIcon = styled($Icon).attrs({})`
  width: 16px;
  height: 90%;
  margin-bottom: 3px;
  margin-right: 2px;
`;

export const StyledButton = styled(Button)`
  width: ${({isMobile}) => (isMobile ? '350px' : '428px')};
  margin: 30px 0px 20px 0px;
`;

export const ErrorNotification = styled.div`
  color: #f31414;
  font-size: 14px;
  font-family: lato;
  padding: 10px 2px 10px 10px;
  margin-left: 10px;
`;

export const StyledErrorWrapper = styled.div`
  display: flex;
`;

export const StyledErrorIcon = styled($Icon).attrs({})`
  width: 16px;
  color: #f31414;
  display: inline-block;
  margin-top: 9px;
  position: absolute;
`;

export const getHeight = () => ({
  height: '56px',
  padding: '0px 40px 0px 16px'
});

export const StyledButtonLink = styled.a`
  color: ${commonPalette.textBrand};
  &:hover {
    color: ${commonPalette.textBrand};
  }
`;

export const StyledLink = styled.a`
  text-decoration: underline;
  color: #f31414;
  cursor: pointer;
  &:hover {
    color: #f31414;
  }
`;
